<div class="right-cut-lines" [class.extended]="layoutInstructions | isExtendedCutLine">
  <div class="top-bleeding-space" [style.height.px]="layoutInstructions | withContentBleed: false"></div>
  <ng-template ngFor [ngForOf]="layoutInstructions | iterableCardStackRows: nCardsOnPage" let-last="last">
    <div class="spacer" [style.height.px]="layoutInstructions | cardContentHeight"></div>
    <div
      *ngIf="!last"
      class="dividing-sliver-container"
      [style.height.px]="
        layoutInstructions
          | withContentBleed
            : false
            : 2
            : (!(layoutInstructions | nonPerforatedBleedBorderInInches)
                ? GRID_COLUMN_GAP_WITH_NO_BLEED_ON_REGULAR_PAPER
                : 0)
      ">
      <div
        class="dividing-sliver"
        [style.width]="
          layoutInstructions | calculateExtendedCutLineLengthString: (layoutInstructions | withContentBleed: false)
        "
        [style.right.px]="
          layoutInstructions | cutLineExtendedLengthInPx: (layoutInstructions | withContentBleed: false)
        "
        [style.border-bottom]="(layoutInstructions | withContentBleed: false) === 0 ? 'unset' : null"></div>
      <div
        class="dividing-sliver-vertical-top-line"
        [style.height.px]="layoutInstructions | cutLineExtendedLengthInPx"
        [style.top.px]="-(layoutInstructions | cutLineExtendedLengthInPx)"
        [style.left.px]="-(layoutInstructions | withContentBleed: false)"></div>
      <div
        class="dividing-sliver-vertical-middle-line"
        [style.height.px]="layoutInstructions | withContentBleed: false : 2"
        [style.top.px]="0"
        [style.left.px]="-(layoutInstructions | withContentBleed: false)"></div>
      <div
        class="dividing-sliver-vertical-bottom-line"
        [style.height.px]="layoutInstructions | cutLineExtendedLengthInPx"
        [style.top.px]="layoutInstructions | withContentBleed: false : 2"
        [style.left.px]="-(layoutInstructions | withContentBleed: false)"></div>
    </div>
  </ng-template>
  <div class="bottom-bleeding-space" [style.height.px]="layoutInstructions | withContentBleed: false"></div>
</div>
